module.exports = __webpack_public_path__ + "b5624aec87a2c2cf0dafc711964fb528.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-service-img6.jpg
// module id = 250
// module chunks = 2